"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.array.reduce.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageItem = exports.ButtonGroup = exports.Button = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _MinusOutlined = _interopRequireDefault(require("@ant-design/icons/MinusOutlined"));

var _PlusOutlined = _interopRequireDefault(require("@ant-design/icons/PlusOutlined"));

var _DecoratorsRoot = require("../../layout/DecoratorsRoot");

var _link = _interopRequireDefault(require("@meepshop/link"));

var _useButtonSettings4 = _interopRequireDefault(require("../../hooks/useButtonSettings"));

var _utils = require("../../nav/utils");

var _Icon = _interopRequireDefault(require("../../menu/Icon"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Button = function Button(_ref) {
  var styles = _ref.styles,
      page = _ref.page,
      level = _ref.level,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      useIcon = _ref.useIcon,
      _onClick = _ref.onClick;

  var _useButtonSettings = (0, _useButtonSettings4["default"])(page),
      title = _useButtonSettings.title,
      url = _useButtonSettings.url,
      action = _useButtonSettings.action,
      target = _useButtonSettings.target;

  var _useContext = (0, _react.useContext)(_DecoratorsRoot.EnhancerContext),
      isLogin = _useContext.isLogin;

  var iconProps = (0, _utils.getIconProps)(page, {
    isLogin: isLogin
  });
  var Comp = url ? 'a' : 'button';
  return /*#__PURE__*/_react["default"].createElement(Comp, {
    className: "\n        ".concat(styles.button, "\n        ").concat(level === 0 ? styles.pageItem : '', "\n        ").concat(level > 0 ? styles.subButton : styles.rootButton, "\n        ").concat(className, "\n      "),
    style: {
      gridTemplateColumns: useIcon ? '20px 1fr' : '1fr'
    },
    type: "button",
    href: url,
    target: target,
    onClick: function onClick(ev) {
      if (action) action(ev);
      if (_onClick) _onClick(ev);
    }
  }, useIcon && /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({}, iconProps, {
    iconSize: 20,
    className: styles.buttonTextIcon
  })), /*#__PURE__*/_react["default"].createElement("span", {
    className: styles.buttonText
  }, title));
};

exports.Button = Button;

var ButtonGroup = function ButtonGroup(_ref2) {
  var styles = _ref2.styles,
      page = _ref2.page,
      level = _ref2.level,
      useIcon = _ref2.useIcon,
      paddingLeftOffset = _ref2.paddingLeftOffset,
      groupOpenIcon = _ref2.groupOpenIcon,
      groupCloseIcon = _ref2.groupCloseIcon;

  var _useButtonSettings2 = (0, _useButtonSettings4["default"])(page),
      title = _useButtonSettings2.title,
      url = _useButtonSettings2.url,
      target = _useButtonSettings2.target,
      isActive = _useButtonSettings2.isActive;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var _useContext2 = (0, _react.useContext)(_DecoratorsRoot.EnhancerContext),
      isLogin = _useContext2.isLogin;

  var iconProps = (0, _utils.getIconProps)(page, {
    isLogin: isLogin
  });

  var handleGroupClick = function handleGroupClick(e) {
    e.stopPropagation();
    e.preventDefault();
    setOpen(!open);
    return false;
  };

  var rootClassName = "".concat(level === 0 ? styles.pageItem : '');
  var linkClassName = "".concat(styles.button, " ").concat(level > 0 ? styles.subButton : styles.rootButton, " ").concat(open ? 'is-active' : ''); // 如果在相同頁面了，保持點擊展開子選單的行為

  var shouldKeepOriginalBehavior = isActive && target !== '_blank';
  var linkStyles = {
    gridTemplateColumns: useIcon ? '20px 1fr 50px' : '1fr 50px'
  };
  var getMaxHeight = (0, _react.useCallback)(function (groupPage) {
    var rowHeight = 50; // 這個數字是為了讓子選單的按鈕有足夠的空間

    if (!groupPage.pages) return rowHeight;
    return groupPage.pages.length * rowHeight + groupPage.pages.reduce(function (acc, child) {
      if (child.pages) {
        return acc + getMaxHeight(child);
      }

      return acc;
    }, 0);
  }, []);
  var renderLink = url && !shouldKeepOriginalBehavior ? /*#__PURE__*/_react["default"].createElement(_link["default"], {
    href: url,
    target: target,
    passHref: true
  }, /*#__PURE__*/_react["default"].createElement("a", {
    className: linkClassName,
    style: linkStyles,
    href: url,
    target: target
  }, useIcon && /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({}, iconProps, {
    iconSize: 20
  })), /*#__PURE__*/_react["default"].createElement("span", {
    className: styles.buttonText
  }, title), /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.arrow,
    onClick: handleGroupClick
  }, open ? groupOpenIcon !== null && groupOpenIcon !== void 0 ? groupOpenIcon : /*#__PURE__*/_react["default"].createElement(_MinusOutlined["default"], null) : groupCloseIcon !== null && groupCloseIcon !== void 0 ? groupCloseIcon : /*#__PURE__*/_react["default"].createElement(_PlusOutlined["default"], null)))) : /*#__PURE__*/_react["default"].createElement("button", {
    className: linkClassName,
    style: linkStyles,
    type: "button",
    onClick: handleGroupClick
  }, useIcon && /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({}, iconProps, {
    iconSize: 20
  })), /*#__PURE__*/_react["default"].createElement("span", {
    className: styles.buttonText
  }, title), /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.arrow
  }, open ? groupOpenIcon !== null && groupOpenIcon !== void 0 ? groupOpenIcon : /*#__PURE__*/_react["default"].createElement(_MinusOutlined["default"], null) : groupCloseIcon !== null && groupCloseIcon !== void 0 ? groupCloseIcon : /*#__PURE__*/_react["default"].createElement(_PlusOutlined["default"], null)));
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: rootClassName
  }, renderLink, /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(styles.buttonGroupSubmenu, " ").concat(open ? 'is-open' : ''),
    style: {
      maxHeight: open ? Math.max(getMaxHeight(page), 1000) : 0
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      padding: level === 0 ? '4px 0' : undefined,
      paddingLeft: level ? level * paddingLeftOffset : 0
    }
  }, page.pages.map(function (child) {
    return /*#__PURE__*/_react["default"].createElement(PageItem, {
      styles: styles,
      key: child.id,
      page: child,
      level: level + 1,
      groupOpenIcon: groupOpenIcon,
      groupCloseIcon: groupCloseIcon,
      paddingLeftOffset: paddingLeftOffset
    });
  }))));
}; // styles: {
//   pageItem: string; - root page
//   button: string; + is-active - 所有按鈕的預設樣式
//   rootButton: string; - 根頁面的按鈕
//   subButton: string; - 子頁面的按鈕
//   buttonGroupSubmenu: string; + is-open - 按鈕群組的子頁面
// }


exports.ButtonGroup = ButtonGroup;

var PageItem = function PageItem(_ref3) {
  var styles = _ref3.styles,
      page = _ref3.page,
      _ref3$level = _ref3.level,
      level = _ref3$level === void 0 ? 0 : _ref3$level,
      useIcon = _ref3.useIcon,
      groupOpenIcon = _ref3.groupOpenIcon,
      groupCloseIcon = _ref3.groupCloseIcon,
      paddingLeftOffset = _ref3.paddingLeftOffset;

  var _useButtonSettings3 = (0, _useButtonSettings4["default"])(page),
      hasGroup = _useButtonSettings3.hasGroup;

  if (hasGroup) {
    return /*#__PURE__*/_react["default"].createElement(ButtonGroup, {
      styles: styles,
      page: page,
      level: level,
      useIcon: useIcon,
      groupOpenIcon: groupOpenIcon,
      groupCloseIcon: groupCloseIcon,
      paddingLeftOffset: paddingLeftOffset
    });
  }

  return /*#__PURE__*/_react["default"].createElement(Button, {
    styles: styles,
    page: page,
    level: level,
    useIcon: useIcon
  });
};

exports.PageItem = PageItem;